<template>
  <div class="flex">
    <input
      type="number"
      class="input w-full min-w-[40px] max-w-[60px] appearance-none rounded p-1 text-center font-bold outline-none"
      :value="value"
      :min="min"
      :max="max"
      @input="onInput"
      @focusout="onFocusOut"
      @keypress="onOnlyNumbers"
    />
  </div>
</template>

<script setup lang="ts">
const props = withDefaults(
  defineProps<{
    value?: number
    min?: number
    max?: number
  }>(),
  {
    value: 0,
    min: 0,
    max: 100,
  },
)

const emit = defineEmits(['input'])

const onOnlyNumbers = (e: KeyboardEvent) => {
  const charCode = e.which ? e.which : e.keyCode
  if (charCode > 31 && (charCode < 48 || charCode > 57)) {
    e.preventDefault()
  }
}

const onInput = (e: Event) => {
  const target = e.target as HTMLInputElement
  const value = parseInt(target.value)

  if (isNaN(value)) return
  if (value < 0) return

  emit('input', value)
}

const onFocusOut = (e: Event) => {
  const target = e.target as HTMLInputElement
  const value = target.value
  if (value === '') {
    target.value = props.value.toString()
  }
}
</script>

<style scoped>
.input {
  box-shadow:
    0 1px 3px 0 rgb(0 0 0 / 20%),
    0 2px 1px 0 rgb(0 0 0 / 12%),
    0 1px 1px 0 rgb(0 0 0 / 14%);
  background-color: #d9d9d9;
}

input[type='number']::-webkit-inner-spin-button,
input[type='number']::-webkit-outer-spin-button {
  appearance: none;
  margin: 0;
}
</style>
